import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChatbotService } from '../../../services/chatbot-services/chatbot.service';
import { LoggerService } from 'src/services/logger-services/logger.service';

@Component({
  selector: 'app-rtq-metadata',
  templateUrl: './rtq-metadata.component.html',
  styleUrls: []
})
export class RtqMetadataComponent implements OnInit {
  @Input() chatdata: any;
  @Input() configdata: any; // Added line to accept configdata as input
  metadata: any;
  error: boolean = false;
  errorMessage: string = '';
  

  constructor(
    private readonly chatbotService: ChatbotService,
    private readonly http: HttpClient,
    private readonly loggerService: LoggerService
  ) {}

  /** Error template for RTQ METADATA */
  private readonly rtqMetadataError = (error: any) =>
    `[RTQ METADATA OLD] - ${JSON.stringify(error)}`;

  ngOnInit(): void {
  }

  downloadDocument(documentId: string): void {

    
    this.chatbotService.DownloadRtqFile(documentId).subscribe({
      next: (data) => {
      if (data.code === 200 && data.data) {
        this.downloadFileFromUrl(data.data, documentId);
      } else {
        this.loggerService.logError(this.rtqMetadataError(`Download failed: ${data.message}`), "downloadDocument")
      }
    }
  })
    
  }

  downloadFileFromUrl(url: string, documentId: string): void {
    try {
      const a = document.createElement('a');
      a.href = url;
      a.download = documentId; 
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      this.loggerService.logError(this.rtqMetadataError(error), "downloadFileFromUrl")
    }
  }

}